const ENHANCED_ATTR = "data-app-select2";
const TARGET_SELECTOR = "select.js-select2:not([data-no-select2])";

function getJQuery() {
  return window.jQuery || window.$ || null;
}

function canEnhance($, el) {
  if (!el || el.tagName !== "SELECT") return false;
  if (!el.classList.contains("js-select2")) return false;
  if (el.hasAttribute("data-no-select2")) return false;
  if (el.hasAttribute(ENHANCED_ATTR)) return false;
  if (typeof $.fn?.select2 !== "function") return false;
  return true;
}

function enhanceSelect($, el) {
  if (!canEnhance($, el)) return;
  const $el = $(el);
  $el.select2({
    width: "100%",
    minimumResultsForSearch: 0,
  });
  el.setAttribute(ENHANCED_ATTR, "1");
}

function enhanceWithin(root = document) {
  const $ = getJQuery();
  if (!$) return false;

  const selects = root.querySelectorAll(TARGET_SELECTOR);
  selects.forEach((el) => enhanceSelect($, el));
  return true;
}

function injectSelect2ResultsHeight() {
  if (document.getElementById("app-select2-style")) return;
  const style = document.createElement("style");
  style.id = "app-select2-style";
  style.textContent = `
    .select2-results > .select2-results__options {
      max-height: 180px;
    }
  `;
  document.head.appendChild(style);
}

export function startGlobalSelect2(router) {
  injectSelect2ResultsHeight();

  const tryInit = () => enhanceWithin(document);
  if (!tryInit()) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (tryInit() || attempts >= 40) window.clearInterval(timer);
    }, 150);
  }

  const observer = new MutationObserver((mutations) => {
    const $ = getJQuery();
    if (!$) return;
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.tagName === "SELECT" && node.matches(TARGET_SELECTOR)) enhanceSelect($, node);
        else enhanceWithin(node);
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  if (router?.afterEach) {
    router.afterEach(() => {
      setTimeout(() => enhanceWithin(document), 0);
    });
  }
}
